import { createAction, props } from '@ngrx/store';

export const fetchDashboardCardsData = createAction('[Data] Fetch Dashboard Cards Data');
export const fetchDashboardCardsDataSuccess = createAction('[Data] Fetch Dashboard Cards Data Success', props<{ response: any }>());
export const fetchDashboardCardsDataFailure = createAction('[Data] Fetch Dashboard Cards Data Failure', props<{ error: string }>());

export const fetchDashboardGraphStatsData = createAction('[Data] Fetch Dashboard Graph Stats Data');
export const fetchDashboardGraphStatsDataSuccess = createAction('[Data] Fetch Dashboard Graph Stats Data Success', props<{ response: any }>());
export const fetchDashboardGraphStatsDataFailure = createAction('[Data] Fetch Dashboard Graph Stats Data Failure', props<{ error: string }>());

